











import Vue from 'vue';
import { defineComponent, PropType } from 'vue';

import { maxLength, minLength, required } from 'src/validators/validators';
import i18n from 'src/translate/lang';

import ListInput from './list-input.vue';

export default defineComponent({
  name: 'ListInputName',
  components: { ListInput },
  props: {
    required: {
      type: Boolean as PropType<boolean>,
      default: () => false,
    },
    showError: Boolean as PropType<boolean>,
    value: {
      type: null,
    },
    label: {
      type: String as PropType<string>,
      default: () => i18n.t('global.fields.name.label'),
    },
    placeholder: {
      type: String as PropType<string>,
      default: () => i18n.t('global.fields.name.placeholder'),
    },
    info: {
      type: String as PropType<string>,
    },
    keyboardHack: Boolean as PropType<boolean>,
  },
  data: () => ({
    validationParams: {
      maxLength: maxLength(30),
      minLength: minLength(1),
      $autoDirty: true,
    } as any,
  }),
  watch: {
    required: {
      handler(value: boolean) {
        if (value) {
          this.validationParams.required = required;
        } else {
          Vue.delete(this.validationParams, 'required');
        }
      },
      immediate: true,
    },
  },
});
